import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import AddInventoryTab from "../InventoryTabs/AddInventoryTab";

export default function InfoTab(props) {
  const { ...rest } = props;
  return <AddInventoryTab {...rest} />;
}
